// Available methods to sort the tasks list. String values are human-readable identifiers
// persisted in session, so they must remain stable.
export enum TaskSortMethod {
  EXPECTED_DATE = 'expected_date',
  PRIORITY_EXPECTED_DATE = 'priority__expected_date',
  IMMEDIATE_PRIORITY_EXPECTED_DATE = 'immediate__priority__expected_date',
  IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS = 'immediate__priority__expected_date__status',
}

export enum TaskSortMethodHumanReadable {
  EXPECTED_DATE = 'expected_date',
  PRIORITY_EXPECTED_DATE = 'priority > expected_date',
  IMMEDIATE_PRIORITY_EXPECTED_DATE = 'immediate > priority > expected_date',
  IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS = 'immediate > priority > expected_date > status',
}

// Default sort method used when the session does not have one stored yet.
// It matches the last (most complete) option shown in the sort modal.
export const DEFAULT_TASK_SORT_METHOD: TaskSortMethod = TaskSortMethod.IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS;

export type TaskSortMethodOption = {
  id: TaskSortMethod;
  labelKey: string;
};

// Ordered list of sort options, used to build the sort modal.
export const TASK_SORT_METHOD_OPTIONS: Array<TaskSortMethodOption> = [
  {
    id: TaskSortMethod.EXPECTED_DATE,
    labelKey: 'TASKS.SORT.EXPECTED_DATE',
  },
  {
    id: TaskSortMethod.PRIORITY_EXPECTED_DATE,
    labelKey: 'TASKS.SORT.PRIORITY_EXPECTED_DATE',
  },
  {
    id: TaskSortMethod.IMMEDIATE_PRIORITY_EXPECTED_DATE,
    labelKey: 'TASKS.SORT.IMMEDIATE_PRIORITY_EXPECTED_DATE',
  },
  {
    id: TaskSortMethod.IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS,
    labelKey: 'TASKS.SORT.IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS',
  },
];

export const tasksSortMethodHumanReadable = (input: TaskSortMethod): string => {
  switch (input) {
    case TaskSortMethod.EXPECTED_DATE:
      return TaskSortMethodHumanReadable.EXPECTED_DATE;
    case TaskSortMethod.PRIORITY_EXPECTED_DATE:
      return TaskSortMethodHumanReadable.PRIORITY_EXPECTED_DATE;
    case TaskSortMethod.IMMEDIATE_PRIORITY_EXPECTED_DATE:
      return TaskSortMethodHumanReadable.IMMEDIATE_PRIORITY_EXPECTED_DATE;
    case TaskSortMethod.IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS:
      return TaskSortMethodHumanReadable.IMMEDIATE_PRIORITY_EXPECTED_DATE_STATUS;
  }
};
